module.exports = __webpack_public_path__ + "static/media/seemypetcam-3.ac8df415.png";